// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const light = "rgba(48, 49, 51, 0.1)";
const lighter = "rgba(48, 49, 51, 0.05)";

const shadows: Styleguide["shadows"] = {
    light20: `0 0 1px 0 ${lighter}, 0 1px 3px 0 ${light}`,
    light40: `0 0 1px 0 ${lighter}, 0 2px 4px 0 ${light}`,
    light60: `0 0 1px 0 ${lighter}, 0 4px 8px 0 ${light}`,
    light80: `0 0 1px 0 ${lighter}, 0 8px 16px 0 ${light}`,
    light100: `0 0 1px 0 ${lighter}, 0 16px 24px 0 ${light}`,
    light60up: `0 0 1px 0 ${lighter}, 0 -8px 16px 0 ${light};`,
};

export default shadows;
